class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

// Track whether the user has moved the mouse at least once since the page
// loaded. Used by HeaderMenu to suppress the very-first hover-open that would
// otherwise fire when a page loads with the cursor parked on a menu item
// (typical right after the user clicked the link to navigate here).
let mouseHasMovedSinceLoad = false;
document.addEventListener(
  'mousemove',
  () => {
    mouseHasMovedSinceLoad = true;
  },
  { once: true }
);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Open dropdown on hover (desktop). Touch + keyboard still works via the
    // <summary> caret as a click target. matchMedia gate avoids opening on
    // small screens / touch devices where hover is unreliable. Use a brief
    // close-delay so the cursor can travel from the parent link down to the
    // submenu without the dropdown collapsing mid-flight.
    if (this.classList.contains('header-menu--hover-open') && window.matchMedia('(hover: hover)').matches) {
      let closeTimer;
      this.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
        if (!mouseHasMovedSinceLoad) return;
        this.mainDetailsToggle.setAttribute('open', '');
      });
      this.addEventListener('mouseleave', () => {
        closeTimer = setTimeout(() => this.close(), 250);
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
